import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/tier-list-kwc/kl-germany.png")